import React from "react";
import {
  StateSwitcherSelectors,
  UserContextSelectors
} from "../redux/selectors";
import { useSelector } from "react-redux";

export const LogoState = () => {
  const selectedState = useSelector(StateSwitcherSelectors.selectedState);
  const brandId = useSelector(UserContextSelectors.brandId);

  return (
    selectedState && (
      <b className={`logo-active logo-active-${brandId}`}>
        {selectedState?.code}
      </b>
    )
  );
};
